import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import mixins from './mixins'

//plugins
import VueSimpleSVG from 'vue-simple-svg'
import vSelect from 'vue-select'
import Tabs from 'vue-tabs-component'
import VTooltip from 'v-tooltip'
import ToggleButton from 'vue-js-toggle-button'
 
Vue.use(VueSimpleSVG)
Vue.use(Tabs)
Vue.use(VTooltip)
Vue.use(ToggleButton)
Vue.component('v-select', vSelect)

new Vue({
  el: '#app',
	render: h => h(App),
	router,
	store
})



// WEBPACK FOOTER //
// ./src/main.js